// @flow

import persistState from 'redux-localstorage'

const paths = ['user', 'locale']

const config = {
  key: 'neeuro-redux'
}

export function readLocalStorage<T>(key:string, defaultVal:T):T{
  if(window.localStorage.getItem(config.key)){
    try {
      const store = JSON.parse(window.localStorage.getItem(config.key))
      return store[key] || defaultVal
    } catch (e) {
      return defaultVal
    }

  }else{
    return defaultVal
  }

}

export default persistState(paths, config)



// WEBPACK FOOTER //
// ./src/store/localStorage.js